import { createContext } from 'preact';

import type { ConfigMap } from 'Models/uiConfig/requestTypes';

export type FacetPanelSearchOptions = ConfigMap;

interface FacetPanelConfig {
  facetPanelName: string;
  valuesCountToShowFilterInput: number;
  showAllAlways?: true;
  disableCollapse?: true;
  initCollapsed?: boolean;
  initExpandedFacets?: string[];
  initCollapsedFacets?: string[];
  searchOptions?: FacetPanelSearchOptions;
}

export default createContext<FacetPanelConfig>({ facetPanelName: '', valuesCountToShowFilterInput: 30 });

export const FacetDialogName = 'FacetDialog';
